<div class="game-dashboard-block ranking-list-block" brtBorderGradient>

  <div class="ranking-list-block__headline">
    <brt-dashboard-boxes-head [data]="headlineBoxData"></brt-dashboard-boxes-head>
  </div>

  <div class="ranking-list-block__content">
    <div class="ranking-list-block__items">
      <brt-ranking-list [items]="ranking" [classId]="schoolClassId"></brt-ranking-list>
    </div>

    <div class="ranking-list-block__footer">
      <brt-button [color]="'white'" [size]="'small'" [title]="'Alle anzeigen'" (click)="openFullList();"></brt-button>
    </div>
  </div>

</div>
